// extracted by mini-css-extract-plugin
export var button = "button-module--button--1SBlZ";
export var primary = "button-module--primary--1Gzk5";
export var secondary = "button-module--secondary--3hM1Y";
export var danger = "button-module--danger--3ETc0";
export var square = "button-module--square--3xWqR";
export var rounded = "button-module--rounded--3nFJf";
export var fill = "button-module--fill--2krks";